import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { EditorState, LexicalEditor } from 'lexical';
import { useEffect, useMemo } from 'react';

export interface ControlledLexicalPluginProps<T = EditorState> {
  value: T;
  getCurrentValue: (editor: LexicalEditor) => T;
  updater?: (value: T, editor: LexicalEditor) => void;
}

export function ControlledLexicalPlugin<T = EditorState>({
  value,
  getCurrentValue,
  updater,
}: ControlledLexicalPluginProps<T>) {
  const [editor] = useLexicalComposerContext();
  const doUpdate = useMemo(
    () => updater ?? ((value: T) => editor.setEditorState(value as EditorState)),
    [editor, updater],
  );

  useEffect(() => {
    const currentValue = getCurrentValue(editor);
    value !== undefined &&
      value !== null &&
      value !== currentValue &&
      editor.update(() => doUpdate(value, editor));
  }, [doUpdate, editor, getCurrentValue, value]);

  return null;
}
